import React, { createContext, useState, useMemo, useContext } from 'react'

const OfferContext = createContext(null)

const OfferProvider = ({ children }) => {
    const [currentOffer, setCurrentOffer] = useState(null)

    const memoizedValues = useMemo(
        () => ({ currentOffer, setCurrentOffer }),
        [currentOffer, setCurrentOffer],
      );

    return (
        <OfferContext.Provider value={memoizedValues}>
         {children}
        </OfferContext.Provider>
    )
}

function useOffer() {
    const context = useContext(OfferContext)

    if(!context) {
        throw new Error('useOffer must be used within a OfferProvider')
    }

    return context;
}

export { OfferProvider, useOffer }